/**
 * Stories feature flags (Vue CLI: baked in at build time — restart dev server after .env change).
 *
 * VUE_APP_STORIES_ENABLED=false
 *   → No story API calls (tray hidden).
 *
 * VUE_APP_STORIES_V2_ENABLED=false (or unset)
 *   → v1 preview mode: /stories/Feed, ActiveStories, UserStories, view, react, reply…
 *   → No create studio, no /v2/stories/* (except blocked at service layer).
 *
 * VUE_APP_STORIES_V2_ENABLED=true
 *   → v2-first for feed, view-event, react, reply, report, viewers, tray, create…
 *   → Falls back to matching v1 route if v2 returns 404/405/501.
 *   → List reads without v2 equivalent stay on v1: ActiveStories, UserStories, PageStories, GET /stories/:id.
 */

export function isStoriesEnabled() {
  return process.env.VUE_APP_STORIES_ENABLED !== 'false';
}

/** v1 preview-only (mobile-like reads on /stories/*). Default when env missing. */
export function isStoriesV1PreviewMode() {
  return isStoriesEnabled() && !isStoriesV2Enabled();
}

export function isStoriesV2Enabled() {
  return isStoriesEnabled() && process.env.VUE_APP_STORIES_V2_ENABLED === 'true';
}

/** Create studio + POST /v2/stories — requires v2 flag. */
export function isStoriesCreateEnabled() {
  return isStoriesV2Enabled();
}
